import { get, post, patch, destroy } from './httpClient'

export const getToppingCategoryList = () => get('/topping-category')
export const getToppingList = (query) => get('/topping', query)
export const addToppingCategory = (body) => post('/topping-category/create', body)
export const addTopping = (body) => post('/topping/create', body)
export const updateTopping = (id, body) => patch('/topping/update/' + id, body)
export const updateToppingCategory = (id, body) => patch('/topping-category/update/' + id, body)
export const deleteTopping = (ids) => destroy('/topping/delete', { topping_id: ids })
export const deleteToppingCategory = (ids) =>
  destroy('/topping-category/delete', { topping_category_id: ids })
